import useSWR from "swr";

import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ToastProvider";
import { post } from "@/lib/api";

const fetcher = (url: string) => fetch(url, { credentials: "include" }).then((res) => res.json());

export function CRMAudienceSync() {
  const { data, isLoading, mutate } = useSWR("/marketing/audience/crm-sync", fetcher);
  const { push } = useToast();

  const handleSync = async () => {
    try {
      await post("/marketing/audience/sync-now", {});
      push({ title: "Sync queued", message: "CRM to marketing audience sync kicked off." });
      await mutate();
    } catch (error) {
      push({
        title: "Unable to sync",
        message: error instanceof Error ? error.message : "Try again later.",
        variant: "destructive",
      });
    }
  };

  return (
    <Card className="space-y-3 border-border/70 bg-background/40 p-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-semibold text-foreground">CRM Audience Sync</p>
          <p className="text-xs text-muted-foreground">Email lists, VIPs, and geo clusters stay synchronized.</p>
        </div>
        <Button size="sm" onClick={() => void handleSync()}>
          Sync now
        </Button>
      </div>
      {isLoading ? (
        <p className="text-xs text-muted-foreground">Loading status…</p>
      ) : (
        <div className="grid gap-2 text-sm text-foreground/80">
          <div className="flex justify-between">
            <span>Last sync</span>
            <span>{data?.last_sync ?? "–"}</span>
          </div>
          <div className="flex justify-between">
            <span>Next sync</span>
            <span>{data?.next_sync ?? "–"}</span>
          </div>
          <div className="flex justify-between">
            <span>Email lists</span>
            <span>{data?.lists_synced ?? 0}</span>
          </div>
          <div className="flex justify-between">
            <span>Geo clusters</span>
            <span>{data?.geo_clusters ?? 0}</span>
          </div>
          <div className="flex justify-between">
            <span>VIP supporters</span>
            <span>{data?.vip_count ?? 0}</span>
          </div>
          <div className="text-xs text-muted-foreground">Status: {data?.status ?? "unknown"}</div>
        </div>
      )}
    </Card>
  );
}
